import http from 'services/http-service';

const ProductService = {

    GetAll(skipCount: number, maxResultCount: number) {
        var response = http.get(`/products/all?keyword=&skipCount=${skipCount}&maxResultCount=${maxResultCount}`);
        return response;
    }
};

export default ProductService;